export default class BaseApiRequestModel {
  /** Auth token sent as X-Access-Token (never in query string). */
  AccessToken: string = '';
}
